import { useUnits } from "@/context/UnitContext";
import { useAuth } from "@/context/AuthContext";
import { Building2 } from "lucide-react";

/**
 * Selector de Unidade exibido no topo da app.
 * - Master: pode escolher "Todas" ou uma unidade específica
 * - Employee com unit_ids: pode alternar apenas entre suas unidades; sem opção "Todas"
 * - Se não há unidades cadastradas, não renderiza nada
 */
export default function UnitSelector() {
  const { units, selectedUnitId, setSelectedUnitId } = useUnits();
  const { user } = useAuth();

  if (!user) return null;
  if (!units || units.length === 0) return null;

  const isMaster = user.role === "master";
  const allowed = !isMaster && user.unit_ids?.length
    ? units.filter((u) => user.unit_ids.includes(u.unit_id))
    : units;

  // Employee preso a uma única unidade -> apenas badge informativo
  if (!isMaster && allowed.length <= 1) {
    if (allowed.length === 0) return null;
    const u = allowed[0];
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs uppercase tracking-widest font-medium liquid-glass-light"
        data-testid="unit-badge"
        style={{ borderLeft: `3px solid ${u.color || "#CBA871"}` }}
      >
        <Building2 className="h-3.5 w-3.5" strokeWidth={1.5} />
        {u.name}
      </div>
    );
  }

  return (
    <select
      data-testid="unit-selector"
      value={selectedUnitId}
      onChange={(e) => setSelectedUnitId(e.target.value)}
      className="liquid-glass-light px-3 py-1.5 rounded-full text-xs uppercase tracking-widest font-medium border-none outline-none cursor-pointer"
      style={{ minWidth: 180 }}
    >
      {isMaster && (
        <option value="all">Todas as unidades</option>
      )}
      {allowed.map((u) => (
        <option key={u.unit_id} value={u.unit_id} data-testid={`unit-option-${u.unit_id}`}>
          {u.name}
        </option>
      ))}
    </select>
  );
}
